module.exports = __webpack_public_path__ + "img/Id1.4a2f95d7.png";